import { getConfigValue } from "@jutro/config";
import { authTokenHandler, createJsonHttpRequest, zipkinTraceHandler } from "@jutro/transport";
var zipkinHandlerInstance = null;
export var createTSMRequest = function (serverUrl) {
  return createJsonHttpRequest(serverUrl, !1).addHandler((zipkinHandlerInstance || (zipkinHandlerInstance = zipkinTraceHandler("TSM", "Jutro with TSM")), zipkinHandlerInstance)).addHandler(authTokenHandler);
};
export var isTSMEnabled = function () {
  return getConfigValue("JUTRO_AUTH_ENABLED", !1) && getConfigValue("JUTRO_TSM_ENABLED", !1);
};